import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../context/UserContext";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const { user, logoutUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
  };

  return (
    <div className="admin-dashboard-container">
      <header className="admin-header">
        <div className="admin-header-content">
          <h1>
            👑 Admin Dashboard
            <span className="admin-badge">ADMIN</span>
          </h1>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </header>

      <div className="admin-content">
        <div className="welcome-section">
          <h2>Welcome back, {user?.username || user?.email || "Admin"}!</h2>
          <p>
            This is your administrative control panel. From here you can manage
            all aspects of the GoalFlex platform.
          </p>
        </div>

        <div className="dashboard-grid">
          <div className="dashboard-card">
            <div className="card-icon">👥</div>
            <h3 className="card-title">User Management</h3>
            <p className="card-description">
              View, edit, and manage user accounts and permissions.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">📊</div>
            <h3 className="card-title">Analytics</h3>
            <p className="card-description">
              Track platform usage, engagement metrics, and growth statistics.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">⚙️</div>
            <h3 className="card-title">System Settings</h3>
            <p className="card-description">
              Configure system-wide settings and platform preferences.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">📝</div>
            <h3 className="card-title">Content Management</h3>
            <p className="card-description">
              Manage blog posts, pages, and other platform content.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">💳</div>
            <h3 className="card-title">Payments</h3>
            <p className="card-description">
              View transactions, subscriptions, and payment reports.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">🔐</div>
            <h3 className="card-title">Security</h3>
            <p className="card-description">
              Monitor security logs, manage access controls, and view audit
              trails.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">📧</div>
            <h3 className="card-title">Email Templates</h3>
            <p className="card-description">
              Create and manage email templates for user communications.
            </p>
          </div>

          <div className="dashboard-card">
            <div className="card-icon">🛠️</div>
            <h3 className="card-title">Developer Tools</h3>
            <p className="card-description">
              Access API documentation, webhooks, and integration settings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
